
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/penilaian-kinerja/demo/daftar-guru/penetapan-predikat-kinerja/susulan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/penilaian-kinerja/demo/daftar-guru/penetapan-predikat-kinerja/susulan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/penilaian-kinerja/demo/daftar-guru/penetapan-predikat-kinerja/susulan"])
      });
    }
  